<template>
  <div>
    <RecoverAccount
      :title="$t('settings.password.forgotPassword.head')"
      :notice="$t('settings.password.forgotPassword.notice')"
      :confirmHint="$t('settings.password.confirmEmailSent')"
      :requestPath="'forgot'"
    />
  </div>
</template>

<script>

import RecoverAccount from '@/controls/RecoverAccount'

export default {
  components: {
    RecoverAccount,
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';

.form-wrapper {
  min-height: 300px;
  position: relative;
}
.header-container {
  max-width: 1440px;
  margin: 0 auto;
}
.nav-bar {
  padding: 15px 24px;
  width: 100%;
  background: #EBEBEB;
  a {
    color: #0C3A58;
    font-size: 12px;
  }
}

.header {
  margin-top: 20px;
}

.notice-header {
  font-family: Georgia;
  font-weight: bold;
  font-size: 24px;
  padding-left: 20px;
}

.notice-note {
  font-family: Verdana;
  font-size: 16px;
  padding-left: 20px;
}

.reset-pwd-form {
  width: 330px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

label {
  font-family: Verdana;
  font-size: 16px;
  color: #0C3A58;
  .required-flag:after {
    color: #E49405;
    content: '*';
  }
}

.text-input {
  color: #0C3A58;
}

.right-btns {
  margin-top: 16px;
  float: right;
  .btn {
    margin-left: 16px;
  }
}

</style>
<style scoped src="styles/dashboard/style.scss"></style>
